// Auto-generated by scripts/generate-whitelabel.js — DO NOT EDIT
// Generated at: 2026-08-20T07:35:19.418Z

export const WHITELABEL_SUB_PAGES_RESPONSE: any = null;

export const WHITELABEL_SUB_PAGES: any[] = Array.isArray(
  WHITELABEL_SUB_PAGES_RESPONSE?.data
)
  ? WHITELABEL_SUB_PAGES_RESPONSE.data
  : WHITELABEL_SUB_PAGES_RESPONSE?.data &&
      typeof WHITELABEL_SUB_PAGES_RESPONSE.data === 'object' &&
      WHITELABEL_SUB_PAGES_RESPONSE.data.page_id != null
    ? [WHITELABEL_SUB_PAGES_RESPONSE.data]
    : [];
